import React, { memo } from 'react';
import classNames from 'classnames';
import { ScommessaTipo } from 'components/scommesseTipo';
import { DynamicScommessaTipoProps } from 'components/scommesseTipo/types';
import styles from './SportScommesseRenderConditional.module.scss';

type ContentProps = DynamicScommessaTipoProps & {
  className?: string;
};

export const ConditionalContainer = ({
  index,
  children,
  className,
  scommessaKey,
}: {
  index?: number | string;
  children: React.ReactNode;
  className?: string;
  scommessaKey?: string;
}) => (
  <div className={classNames(styles.container, className)} data-testid={scommessaKey} data-idx={index}>
    {children}
  </div>
);

// eslint-disable-next-line react/display-name
const Content = memo(
  function ({ className, ...scommessaProps }: ContentProps) {
    return (
      <div className={classNames(styles.wrapper, className)} suppressHydrationWarning>
        <ScommessaTipo {...scommessaProps} />
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.scommessaKey === nextProps.scommessaKey && prevProps.scommessaTipo === nextProps.scommessaTipo
);
ConditionalContainer.Content = Content;